import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "../../shared/Button";
import { RejectTicketDialogProps } from "../../../interface/dialog/RejectTicketDialogProps";
import { useDialogStyles } from "../../shared/dialog/styles";

const RejectTicketDialog: React.FC<RejectTicketDialogProps> = ({
  open,
  rejectReason,
  onClose,
  onChange,
  onSubmit,
}) => {
  const classes = useDialogStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ style: { overflowX: "hidden" } }}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h5">Reject Ticket</Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Please provide a reason for rejecting the ticket. This will mark the
          ticket as rejected and clear dispatch information.
        </Typography>
      </DialogTitle>

      <DialogContent
        dividers
        className={classes.dialogContentDividers}
      >
        <TextField
          label="Reason for rejection"
          multiline
          minRows={4}
          fullWidth
          variant="outlined"
          value={rejectReason}
          onChange={(e) => onChange(e.target.value)}
        />
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            variant="contained"
            color="default"
            onClick={onClose}
            type="button"
          />
        </div>
        <div className={classes.actionButton}>
          <Button
            label="Reject Ticket"
            variant="contained"
            color="primary"
            onClick={onSubmit}
            type="button"
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default RejectTicketDialog;
